"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCustomConsole;
function getCustomConsole(console_name_) {
  var is_debug_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var global_console_ = window.console;
  var console_ = global_console_ && global_console_.getCustom && global_console_.getCustom(console_name_, is_debug_);
  if (console_) return console_;
  function doNothing() {}
  function logCustom() {
    for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
      rest[_key] = arguments[_key];
    }
    global_console_.log.apply(null, ["[".concat(console_name_, "]")].concat(rest));
  }
  function infoCustom() {
    for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      rest[_key2] = arguments[_key2];
    }
    global_console_.info.apply(null, ["[".concat(console_name_, "]")].concat(rest));
  }
  function warnCustom() {
    for (var _len3 = arguments.length, rest = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      rest[_key3] = arguments[_key3];
    }
    global_console_.warn.apply(null, ["[".concat(console_name_, "]")].concat(rest));
  }
  function errorCustom() {
    for (var _len4 = arguments.length, rest = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      rest[_key4] = arguments[_key4];
    }
    global_console_.error.apply(null, ["[".concat(console_name_, "]")].concat(rest));
  }
  console_ = global_console_ && {
    log: is_debug_ ? logCustom : doNothing,
    info: is_debug_ ? infoCustom : doNothing,
    warn: warnCustom,
    error: errorCustom
  };
  if (console_) return console_;
  console_ = {
    log: function log() {},
    info: function info() {},
    warn: function warn() {},
    error: function error() {}
  };
  return console_;
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-advertising/lib/js/console_utils.js
// module id = 1606
// module chunks = 1